import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Concessionaria } from '../_model/concessionaria';
import { Empresa } from '../_model/empresa';
import { Estado } from '../_model/estado';

const pathApi = 'Empresa';

@Injectable({
  providedIn: 'root',
})
export class EmpresaService {

  constructor(private http: HttpClient) { }

  getEmpresas(): Observable<Empresa[]>{
    return this.http.get<Empresa[]>(`${environment.URL_API}/${pathApi}`);
  }

  getEstados(codigoMarca: string, codigoRamo: string): Observable<Estado[]>{
    return this.http.get<Estado[]>(`${environment.URL_API}/${pathApi}/estados/${codigoMarca}/${codigoRamo}`);
  }

  getStatesAndCities(): Observable<Estado[]>{
    return this.http.get<Estado[]>(`${environment.URL_API}/${pathApi}/estados/mercedesBenz/veiculosComerciais/true`);
  }

  getCidades(codigoMarca: string, codigoRamo: string, uf: string): Observable<string[]>{
    return this.http.get<string[]>(`${environment.URL_API}/${pathApi}/cidades/${codigoMarca}/${codigoRamo}/${uf}`);
  }

  getConcessionariasRamo(codigoRamo: string, cidade: string, estado: string): Observable<Empresa[]>  {
    return this.http.post<Empresa[]>(`${environment.URL_API}/${pathApi}/concessionariasRamo`,
      {
        codigoRamo: codigoRamo,
        uf: estado,
        cidade: cidade
      });
  }

  getConcessionarias(marca: string, ramo: string, uf?: string, cidade?: string): Observable<Concessionaria[]> {
    return this.http.post<Concessionaria[]>(`${environment.URL_API}/${pathApi}/concessionarias`,
      {
        codigoMarca: marca,
        codigoRamo: ramo,
        uf,
        cidade
      });
  }
}
